import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef
} from 'react';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import {
  GET_TICKET_LIST,
  UPDATE_TICKET,
  savePersonalization,
  getPersonalization,
  TicketClient
} from '@nile/graphql';
import TicketKanbanCard from '@nile/mangifera/src/Containers/CardContainers/TicketKanbanCard';
import {
  ALL_TABLES,
  AppContext,
  COMMON_CONSTANTS,
  EventEmitter,
  EventEmitterWithIndex,
  generateString,
  Loader,
  rearrangeArrayValue,
  useProduct,
  useSuperListHook,
  useUserMSPCheckHook
} from '@nile/components';
import { cloneDeep, isEmpty, isEqual } from 'lodash';
import { ButtonGroup, Button } from '@superops/ui-design-system';
import { SuperBoard } from '@nile/components/src/react-super-kanban';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TicketKanbanTabs } from '@nile/mangifera/src/Constants/Tickets';
import { KanbanLaneHeader } from '@nile/mangifera/src/Components/Ticket';
import {
  KanbanWrapper,
  HeaderContainer,
  StyledText
} from '@nile/mangifera/src/StyledComponents/KanbanBoardStyles';
import Queries from '@nile/mangifera/src/Queries';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ClosureModal from '../../Components/Ticket/ClosureModal';
import { getWindowId } from '@nile/components/src/Utils/helpers';

// MOCK ERROR RESPONSE
const ERROR_RESPONSE = {
  data: {
    updateTicket: {
      ticketId: '538727285479874560',
      client: {
        name: 'Dunder Muffin',
        accountId: '1234567890'
      },
      site: {
        name: 'Headquaters',
        id: '098776545323'
      }
    }
  },
  errors: [
    {
      extensions: {
        clientError: [
          {
            errorCode: 10012,
            fields: {
              priority: 'Low',
              impact: null,
              urgency: null,
              status: 'Resolved',
              resolutionCode: null,
              category: null,
              cause: 'Cause 1',
              udf4text: 'Custom field text',
              udf3num: '1',
              udf12dec: '1.2',
              udf11para:
                'A list of resolution codes that can be added to a ticket to describe the problem, and the solution provided.',
              udf342select: 'Option 1',
              udf343mselect: ['Option 1', 'Option 3'],
              udf5check: ['Checkbox 1'],
              udf10radio: null,
              udf338date: '2023-02-24', // "2023-02-24"
              udf339dt: '2023-02-24T00:00' // "2023-02-24T00:00"
            }
          }
        ]
      }
    }
  ]
};
// MOCK ERROR RESPONSE

const ROW_COUNT = 20;
const TicketKanbanContainer = (props) => {
  const context = useContext(TicketContext);
  const contextRef = useRef();
  const windowId = getWindowId();
  contextRef.current = context;
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const isMSP = useUserMSPCheckHook();
  const user = {
    firstName: currentUser.firstName,
    userId: currentUser.userId,
    email: currentUser.email,
    lastName: currentUser.lastName
  };
  const { ticketViews } = props;
  const [activeTab, setActiveTab] = useState(
    context?.activeTab?.state?.kanbanTab || 'status'
  );
  const activeTabRef = useRef();
  activeTabRef.current = activeTab;
  const [isLoading, setIsLoading] = useState(true);
  const [kanbanLanes, setKanbanLanes] = useState([]);
  const defaultSort = {
    attribute: 'createdTime',
    order: 'DESC'
  };
  const [kanbanState, setKanbanState] = useState(
    context?.activeTab?.state?.kanbanSort || {}
  );
  const kanbanStateRef = useRef();
  kanbanStateRef.current = kanbanState;
  const viewId = props.match.params.id;

  const activeViewData = ticketViews?.find((item) => {
    return item.id === viewId;
  });

  const { advanceFilterCondition } = useSuperListHook({
    tableName: ALL_TABLES.tickets,
    viewId: viewId
  });

  const [pinnedColumns, setPinnedColumns] = useState({
    technician: ['Unassigned tickets'],
    priority: ['Unassigned tickets'],
    group: ['Unassigned tickets'],
    status: []
  });
  const flags = useFlags();
  const [technicians, setAllTechnicians] = useState([]);
  const [technicianGroups, setAllTechnicianGroups] = useState([]);
  const [priorities, setAllPriorities] = useState([]);
  const [statuses, setAllStatus] = useState([]);
  const [displayLaneCount, setDisplayLaneCount] = useState(10);
  const IntialMap = {
    technician: true
  };

  const [closureModalactive, setClosureModalActive] = useState(false);
  const [closureSaveLoading, setClosureSaveLoading] = useState(false);

  const [errorsOnClosure, setErrorsOnClosure] = useState(null);
  const errorsOnClosureByRef = React.useRef(null);
  errorsOnClosureByRef.current = errorsOnClosure;
  const [showLiveUpdate, setShowLiveUpdate] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [isHighlighting, setIsHighlighting] = useState(false);

  const updateLaneIds = React.useRef([]);
  const [isLiveUpdateInProgress, setIsLiveUpdateInProgress] = useState(false);

  const setUpdateLaneIds = (val) => {
    const isPresent = updateLaneIds?.current?.includes(val);
    if (val && !isPresent) {
      updateLaneIds.current.push(val);
    }
  };

  const getClosureFields = (errorFields) => {
    setClosureModalActive(true);
    setErrorsOnClosure({
      ticket: errorFields?.param?.ticket,
      status: errorFields?.param?.status,
      fields: errorFields?.param?.fields
    });
  };

  useEffect(() => {
    EventEmitter.subscribe('ticketClosureError', getClosureFields);
    setTimeout(() => {
      EventEmitter.dispatch('hideMonicaAi');
    }, 1000);

    return function cleanup() {
      EventEmitter.unsubscribe('ticketClosureError');
    };
  });

  const getColumnSortData = () => {
    getPersonalization({
      userId: currentUser?.userId,
      category: 'TicketKanbanViewPersonalization',
      name: viewId
    })
      .then((response) => {
        if (response) {
          const res = response?.data?.getPersonalizationByCategoryAndName;
          if (res !== null) {
            setKanbanState(JSON.parse(res.value));
          } else {
            setKanbanState({});
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateTicket = (
    source,
    target,
    item,
    board,
    dispatch,
    updatedBoard
  ) => {
    const { ticketId } = item;
    const updateObjectMap = {
      status: {
        status: statuses.find((el) => el.id === target)?.name || null
      },
      priority: {
        priority: priorities.find((el) => el.id === target)?.name || null
      },
      technician: {
        technician: target === 'Unassigned tickets' ? null : { userId: target }
      },
      group: {
        techGroup:
          target === 'Unassigned tickets'
            ? null
            : {
                groupId: target
              },
        technician: null
      }
    };
    if (source !== target) {
      TicketClient.mutate({
        mutation: UPDATE_TICKET,
        variables: {
          id: ticketId,
          ...updateObjectMap[activeTab]
        }
      })
        .then((res) => {
          if (res?.data?.updateTicket) {
            const updatedTicket = res?.data?.updateTicket;
            const newBoardData = cloneDeep(updatedBoard);
            const sourceLaneIdx = newBoardData.findIndex(
              (el) => el.id === source
            );
            const targetLaneIdx = newBoardData.findIndex(
              (el) => el.id === target
            );
            newBoardData[sourceLaneIdx].count -= 1;
            newBoardData[targetLaneIdx].count += 1;
            const itemToUpdate = newBoardData[targetLaneIdx].items.findIndex(
              (el) => el.ticketId === updatedTicket.ticketId
            );
            newBoardData[targetLaneIdx].items[itemToUpdate] = {
              ...newBoardData[targetLaneIdx].items[itemToUpdate],
              ...updatedTicket
            };
            dispatch({ type: 'resetBoard', board: newBoardData });
          } else {
            dispatch({ type: 'resetBoard', board: board });
          }
        })
        .catch((err) => {
          dispatch({ type: 'resetBoard', board: board });
        });
    }
  };

  const updateTicketOnClosure = (ticket, variables) => {
    setClosureSaveLoading(true);
    const ticketId = ticket?.ticketId;
    TicketClient.mutate({
      mutation: UPDATE_TICKET,
      variables: {
        id: ticketId,
        ...variables
      }
    })
      .then((res) => {
        if (res?.data?.updateTicket) {
          setClosureModalActive(false);
          setErrorsOnClosure(null);
        }
        EventEmitter.dispatch('refreshBoard', {});
        setClosureSaveLoading(false);
      })
      .catch((err) => {
        setClosureSaveLoading(false);
      });
  };

  let timeoutId = null;
  const onLiveUpdateComplete = () => {
    setIsHighlighting(true);
    setIsLiveUpdateInProgress(false);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setEventData(null);
    setShowLiveUpdate(false);
    timeoutId = setTimeout(() => {
      setIsHighlighting(false);
      resetLiveUpdateTickets();
      updateLaneIds.current = [];
    }, 2500);
  };

  const attributeMap = {
    technician: 'technician.userId',
    group: 'techGroup.name',
    status: 'status',
    priority: 'priority'
  };
  const getOperandsList = (id) => {
    const conditions = advanceFilterCondition?.operands || [];
    return conditions.concat([
      {
        attribute: attributeMap[activeTab],
        operator: id ? 'is' : 'isEmpty',
        value: id || ''
      }
    ]);
  };
  const fetchTickets = async (
    id,
    params = { page: 1, pageSize: ROW_COUNT }
  ) => {
    const sortData = kanbanState?.[activeTab]
      ? kanbanState?.[activeTab]
      : defaultSort;
    const res = await TicketClient.query({
      query: GET_TICKET_LIST,
      variables: {
        listInfo: {
          view: { id: viewId },
          page: params.page,
          pageSize: params.pageSize,
          condition: {
            joinOperator: 'AND',
            operands: getOperandsList(id)
          },
          sort: [sortData]
        },
        isMSPProduct
      },
      fetchPolicy: 'network-only'
    });
    if (res?.data?.getTicketList?.tickets) {
      if (showLiveUpdate) {
        onLiveUpdateComplete();
      }

      return {
        cards: res?.data?.getTicketList?.tickets.map((ticket) => ({
          ...ticket,
          id: ticket.ticketId
        })),
        count: res?.data?.getTicketList?.listInfo.totalCount
      };
    }
    return [];
  };
  const handlePagination = async (requestedPage, laneId, board) => {
    const refMap = {
      technician: technicians,
      priority: priorities,
      status: statuses,
      group: technicianGroups
    };
    const keyMap = {
      technician: 'id',
      priority: 'name',
      status: 'name',
      group: 'name'
    };
    const currentLaneIndex = board.findIndex((el) => el.id === laneId);
    const currentLane = board[currentLaneIndex];
    const totalCount = currentLane.count;
    if ((requestedPage - 1) * ROW_COUNT < totalCount) {
      const ref = refMap[activeTab];
      const key = keyMap[activeTab];
      const name = ref.find((el) => el.id === laneId)?.[key];
      const ticketResponse = await fetchTickets(name, {
        page: requestedPage,
        pageSize: ROW_COUNT
      });
      return ticketResponse.cards;
    }
    return [];
  };
  const togglePinnedColumns = (action, board) => {
    if (action.type === 'pinColumn' || action.type === 'unpinColumn') {
      const { data: colData } = action.meta;
      const { id: columnId } = colData;
      const personalisedData = {
        user: user,
        name: 'kanbanPinnedColumns',
        category: 'TicketKanbanView'
      };
      let updatedPinnedColumns = [];
      if (action.type === 'unpinColumn') {
        updatedPinnedColumns = [...pinnedColumns?.[activeTab]].filter(
          (col) => col !== columnId
        );
      } else if (action.type === 'pinColumn') {
        updatedPinnedColumns = [...pinnedColumns?.[activeTab], columnId];
      }
      setPinnedColumns({ ...pinnedColumns, [activeTab]: updatedPinnedColumns });
      personalisedData.value = JSON.stringify({
        ...pinnedColumns,
        [activeTab]: updatedPinnedColumns
      });
      savePersonalization({
        variables: personalisedData,
        input: personalisedData
      });
    }
  };
  const tabDataMap = {
    technician: {
      id: 'userId',
      laneId: 'userId',
      unassignedTicket: true,
      getData: Queries.getAllTechnicians,
      setData: setAllTechnicians
    },
    group: {
      id: 'groupId',
      unassignedTicket: true,
      getData: Queries.getAllTechnicianGroups,
      setData: setAllTechnicianGroups
    },
    priority: {
      title: 'value',
      laneId: 'value',
      unassignedTicket: true,
      getData: Queries.getAllPriorities,
      setData: setAllPriorities
    },
    status: {
      getData: Queries.getAllStatus,
      setData: setAllStatus
    }
  };
  const reorderLanes = (lanes) => {
    Queries.getPinnedColumnData(currentUser?.userId).then((res) => {
      const getPersonalizationByCategoryAndName =
        res?.data?.getPersonalizationByCategoryAndName;
      let personalisedPinnedColumns = {};
      if (getPersonalizationByCategoryAndName) {
        personalisedPinnedColumns = JSON.parse(
          getPersonalizationByCategoryAndName?.value
        );

        if (personalisedPinnedColumns) {
          personalisedPinnedColumns = Object.entries(
            personalisedPinnedColumns
          ).reduce((acc, [tabHeader, lanesIds]) => {
            acc[tabHeader] = lanesIds.filter((laneId) => {
              if (laneId === 'Unassigned tickets') return true;

              return lanes.some((lane) => lane.id === laneId);
            });
            return acc;
          }, {});
          setPinnedColumns({
            ...pinnedColumns,
            ...personalisedPinnedColumns
          });
        }
      }

      Queries.getColumnOrder(activeTabRef.current, currentUser?.userId).then(
        (colData) => {
          if (colData?.length) {
            setDisplayLaneCount(colData.length);
            colData.forEach((colId, i) => {
              const columnIdx = lanes.findIndex((lane) => lane?.id === colId);
              if (columnIdx > -1) {
                rearrangeArrayValue(lanes, columnIdx, i);
              }
            });
          } else {
            setDisplayLaneCount(10);
          }
          if (personalisedPinnedColumns?.[activeTabRef.current]?.length) {
            personalisedPinnedColumns?.[activeTabRef.current]?.forEach(
              (colId, i) => {
                const columnIdx = lanes.findIndex((lane) => lane?.id === colId);
                if (columnIdx > -1) {
                  rearrangeArrayValue(lanes, columnIdx, i);
                }
              }
            );
          }
          setKanbanLanes(lanes);
          setIsLoading(false);
        }
      );
    });
  };
  const constructLanes = (tab) => {
    setIsLoading(true);
    const currentTabData = tabDataMap[tab];
    currentTabData?.getData().then((res) => {
      currentTabData?.setData(res);
      let lanes = res?.map((el) => {
        return {
          id: el[currentTabData?.id || 'id'],
          title: el[currentTabData?.title || 'name'],
          laneId: el[currentTabData?.laneId || 'name']
        };
      });
      currentTabData?.unassignedTicket &&
        lanes?.unshift({
          id: 'Unassigned tickets',
          title: `ticket.kanban.unassignedTickets.${tab}`
        });
      reorderLanes(lanes);
    });
  };
  const setLanes = () => {
    constructLanes(activeTab);
  };

  const saveKanbanSort = useCallback(
    (sortData) => {
      const currentState = {
        ...kanbanStateRef.current,
        [activeTabRef.current]: sortData
      };
      setKanbanState(currentState);
      const personalisedData = {
        name: viewId,
        category: 'TicketKanbanViewPersonalization',
        value: JSON.stringify(currentState),
        user: user
      };
      savePersonalization({
        variables: personalisedData,
        input: personalisedData
      });
    },
    [activeTabRef.current, kanbanStateRef.current, viewId, currentUser]
  );
  const saveBoard = (board) => {
    const personalisedData = {
      user: user,
      name: activeTabRef.current,
      category: 'TicketKanbanView'
    };
    const columnOrderNew = board.map((col) => col.id);
    personalisedData.value = JSON.stringify(columnOrderNew);
    // save the board data in personalisation
    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    });
  };
  const boardChangeHandler = (action, board) => {
    switch (action.type) {
      case 'moveList':
      case 'addList':
      case 'addLists':
      case 'unpinColumn':
      case 'removeFromList':
        saveBoard(board);
        break;
      default:
        break;
    }
  };

  const getListItems = async (params) => {
    const { list } = params;
    const ticketResponse = await fetchTickets(list.laneId);
    return new Promise((resolve) => {
      resolve(
        {
          items: ticketResponse.cards,
          params: { count: ticketResponse.count }
        } || { items: [] }
      );
    });
  };

  const handleTabChange = ({ id }) => {
    context.setActiveKanbanTab(id);
    setActiveTab(id);
  };
  const isCardDragRestrictedCheck = ({ cardData }) => {
    if (activeTab !== 'status') {
      return cardData?.client === null;
    }
    return false;
  };
  const activePinnedColumns = pinnedColumns?.[activeTab] || [
    'Unassigned tickets'
  ];
  useEffect(() => {
    setLanes();
  }, [activeTab, advanceFilterCondition]);

  useEffect(() => {
    if (viewId) {
      setLanes();
      getColumnSortData();
    }
  }, [viewId]);

  // useEffect(() => {
  //   const newActiveView = ticketViews.find((item) => {
  //     return item.id === props.match.params.id;
  //   });
  //   context.setActiveView(newActiveView);
  //   setActiveView(newActiveView);
  // }, [props.match.params.id]);

  useEffect(() => {
    EventEmitter.dispatch('refreshBoard', {});
  }, [kanbanState]);
  useEffect(() => {
    getColumnSortData();
    // getPinnedColumnData();
    context.setPersonalization('');
    if (!context.activeKanbanTab) {
      context.setActiveKanbanTab('technician');
    }
    EventEmitter.subscribe('kanbanSort', saveKanbanSort);
    return function cleanup() {
      EventEmitter.unsubscribe('kanbanSort');
    };
  }, []);
  const initial = !!IntialMap?.[activeTabRef?.current];

  const onWebSocketMessage = (wsEventData) => {
    const payload = wsEventData?.payload;
    const type = payload?.type;
    const entity = payload?.page?.entity;
    const pageType = payload?.page?.type;
    const wsWindowId = payload?.page?.windowId;
    if (
      type === 'SERVER_EVENT' &&
      pageType === 'LIST' &&
      entity === 'TicketView' &&
      wsWindowId === windowId
    ) {
      setEventData(eventData);
    }
  };

  const liveUpdateTicketRef = React.useRef([]);

  const setLiveUpdateTickets = (ticketId) => {
    const current = liveUpdateTicketRef?.current
      ? liveUpdateTicketRef?.current
      : [];
    const isPresent = current.find((el) => el === ticketId);
    if (ticketId && !isPresent) {
      current.push(ticketId);
      liveUpdateTicketRef.current = current;
    }
  };

  const resetLiveUpdateTickets = () => {
    liveUpdateTicketRef.current = [];
  };

  const onLiveUpdate = () => {
    if (isEmpty(updateLaneIds?.current)) {
      setIsLiveUpdateInProgress(true);
      EventEmitter.dispatch('refreshBoard');
    } else {
      setIsLiveUpdateInProgress(true);
      updateLaneIds?.current?.forEach((laneId) => {
        EventEmitterWithIndex.dispatch('refreshLanes', {
          lanes: laneId,
          callback: onLiveUpdateComplete
        });
      });
    }
  };

  const [websocketPayLoad, setWebSocketPayLoad] = useState({
    page: {
      type: 'LIST',
      entity: 'TicketView',
      windowId: windowId
    },
    data: {
      viewId: viewId,
      condition: advanceFilterCondition || null,
      allowSimultaneousPage: false
    }
  });
  const [liveUpdateCondition, setLiveUpdateCondition] = useState(
    advanceFilterCondition || null
  );

  useEffect(() => {
    if (isEmpty(advanceFilterCondition) && !isEmpty(liveUpdateCondition)) {
      return;
    }

    const isConditionUpdated = !isEqual(
      advanceFilterCondition,
      liveUpdateCondition
    );

    if (isConditionUpdated) {
      const updatedWsPayLoad = cloneDeep(websocketPayLoad);
      updatedWsPayLoad.data.condition = advanceFilterCondition;
      setWebSocketPayLoad(updatedWsPayLoad);
      setLiveUpdateCondition(advanceFilterCondition);
    }
  }, [advanceFilterCondition, liveUpdateCondition, websocketPayLoad]);

  return (
    <KanbanWrapper>
      <HeaderContainer data-qa="kanbanViews">
        <StyledText>
          <FormattedMessage id="ticket.kanban.grpTickets.header" />
        </StyledText>
        <ButtonGroup>
          {TicketKanbanTabs.map((tab) => (
            <Button
              outline={activeTab === tab.id}
              plain={activeTab !== tab.id}
              monochrome
              onClick={() => handleTabChange(tab)}
            >
              <div data-qa={tab.qa}>
                <FormattedMessage id={tab.label} />
              </div>
            </Button>
          ))}
        </ButtonGroup>
      </HeaderContainer>

      <SuperBoard
        loading={isLoading}
        wsPayload={websocketPayLoad}
        onMessage={onWebSocketMessage}
        showLiveUpdate={showLiveUpdate}
        onLiveUpdateRefresh={onLiveUpdate}
        liveUpdateCondition={liveUpdateCondition}
        enableLiveUpdate={isMSP && flags?.ticketListviewPageRefresh}
        lists={kanbanLanes}
        getListItems={getListItems}
        displayLaneCount={displayLaneCount}
        isLiveUpdateInProgress={isLiveUpdateInProgress}
        onLaneScroll={(requestedPage, laneId, board) => {
          const newCards = handlePagination(requestedPage, laneId, board);
          return new Promise((resolve) => {
            resolve(newCards);
          });
        }}
        middleWares={[togglePinnedColumns]}
        sideEffects={[boardChangeHandler]}
        onCardDrop={(
          sourceId,
          targetId,
          item,
          board,
          dispatch,
          updatedBoard
        ) => {
          updateTicket(sourceId, targetId, item, board, dispatch, updatedBoard);
        }}
        pinColumns
        reorderColumns
        pinnedColumns={activePinnedColumns}
        initial={initial}
        restrictCardDragCheck={isCardDragRestrictedCheck}
        components={{
          Card: (otherProps) => {
            const isCardHighlight =
              isHighlighting &&
              liveUpdateTicketRef.current &&
              liveUpdateTicketRef.current?.find(
                (el) => el === otherProps?.item?.ticketId
              );
            return (
              <TicketKanbanCard
                context={context}
                {...otherProps}
                setLanes={setLanes}
                activeTab={activeTab}
                eventData={eventData}
                setShowLiveUpdate={setShowLiveUpdate}
                isHighlight={isCardHighlight}
                setUpdateLaneIds={setUpdateLaneIds}
                setLiveUpdateTickets={setLiveUpdateTickets}
              />
            );
          },
          ListHeader: (otherProps) => (
            <KanbanLaneHeader
              {...otherProps}
              setLanes={setLanes}
              activeTab={activeTab}
            />
          )
        }}
        refreshButtonStyles={{
          '.refresh-notification': {
            // Target the class directly
            left: '40% !important'
          }
        }}
        registerPageDelay={100}
      />

      {errorsOnClosureByRef.current && (
        <>
          <ClosureModal
            modalActive={closureModalactive}
            setModalActive={setClosureModalActive}
            errorsOnClosure={errorsOnClosureByRef.current}
            setErrorsOnClosure={setErrorsOnClosure}
            onSave={updateTicketOnClosure}
            saveLoading={closureSaveLoading}
            onClose={() => setClosureModalActive(false)}
          />
        </>
      )}
    </KanbanWrapper>
  );
};
export default withRouter(injectIntl(TicketKanbanContainer));
